module.exports = __webpack_public_path__ + "img/ywAward-a.b4c627d1.png";